import { clearCheckInRedirectGuards } from 'src/utils/check-in-redirect';

import { SSO_LOGIN_PATH } from 'src/constants';
import { useSsoRedirectStore } from 'src/store/sso-redirect';

const REDIRECT_PENDING_KEY = 'sso:redirect-pending';
const HANDOFF_MESSAGE = 'Redirecting you to LTA to sign in…';

function runAfterPaint(callback: () => void): void {
  if (typeof requestAnimationFrame !== 'function') {
    setTimeout(callback, 50);
    return;
  }
  requestAnimationFrame(() => requestAnimationFrame(callback));
}

function navigateToSso(returnTo: string): void {
  clearCheckInRedirectGuards();
  sessionStorage.setItem(REDIRECT_PENDING_KEY, '1');
  useSsoRedirectStore.getState().start(HANDOFF_MESSAGE);

  const loginUrl = `${SSO_LOGIN_PATH}?returnTo=${encodeURIComponent(returnTo)}`;
  runAfterPaint(() => window.location.assign(loginUrl));
}

export function startSsoLogin(returnTo = '/'): void {
  if (typeof window === 'undefined') return;
  navigateToSso(returnTo);
}

export function redirectToSsoLogin(returnTo: string): boolean {
  if (typeof window === 'undefined') return false;
  if (sessionStorage.getItem(REDIRECT_PENDING_KEY)) return false;

  navigateToSso(returnTo);
  return true;
}

export function clearSsoRedirectGuard(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(REDIRECT_PENDING_KEY);
}

export function isSsoRedirectPending(): boolean {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem(REDIRECT_PENDING_KEY) === '1';
}
